<template>
    <div class="comment">
        <div class="comment__father">
            <div class="comment__user">
                <div class="user__avatar" :style="{backgroundColor: randomColor(data.userIdentifier)}">
                    <img v-if="data.userImage !== null" :src="getFile(data.userImage, 'user')" />
                    <span v-else :style="{backgroundColor: randomColor(data.userIdentifier)}" class="userImage__null" >{{data.userName.charAt(0)}}</span>
                </div>
                <!-- <div class="user__thread"></div> -->
            </div>
            <div class="comment__container">
                <div class="comment__box">
                    <div class="comment__topline">
                        <div class="user__info"><strong>{{data.userName}}</strong> - {{data.whenCreated.quantity}} {{$t(`date.params.${data.whenCreated.param}`)}}</div>
                        <div v-if="data.canEdit " class="dropdown" :ref="`comment__container_${data.id}`">
                            <input type="checkbox" :id="`comment__container_${data.id}`">
                            <label class="dropdown__face" :for="`comment__container_${data.id}`">
                                <span class="material-icons">more_horiz</span>
                            </label>
                            <ul class="dropdown__items">    
                                <li class="material-icons" @click="toggleModal">delete</li>                                 
                                <li class="material-icons" @click="editEnabled[index] = !editEnabled[index]; closeOptions(data.id)" >edit</li>                                 
                                <li class="material-icons" @click="closeOptions(`comment__container_${data.id}`)" >close</li>                                 
                            </ul>
                        </div>
                    </div>
                    <CommentBox v-if="editEnabled[index]" @postComment="editComment" @discardComment="discardComment" :index="index" :content="data" />
                    <template v-else>
                        <div v-html="data.comment" class="comment__content"></div>
                        <div class="comment__attach" v-if="data.attach.length">
                            <template v-for="(att,idx) in data.attach" :key="idx">
                                <a :href="getFile(att.file, 'foroComment')" target="_blank" >
                                    <img v-if="att.contentType.includes('image')" :src="getFile(att.file,'foroComment')">
                                </a>
                            </template>
                            <template v-for="(att,idx) in data.attach" :key="idx">
                              <a v-if="!att.contentType.includes('image')" :href="getFile(att.file,'foroComment')" target="_blank">
                                <i class="material-icons">attach_file</i><span>{{att.originalFileName}}</span>
                              </a>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="comment__actions">
                    <button :disabled="courseIsFinished" @click="likeUnlike" :class="{'liked': liked}" >
                        <i class="material-icons">favorite</i>
                        {{$t('forum.actions.LIKE')}}
                    </button>
                    <!-- <button @click="commentActivate = !commentActivate" :style="{color: commentActivate ? '#009696' : '#212121' }">
                        <i class="material-icons">comment</i>
                        Comentar
                    </button> -->
                </div>
                <!-- <template v-if="commentActivate">
                    <CommentBox @postComment="postComment" @discardComment="discardComment" :content="data" :index="index" />
                </template> -->

            </div>
        </div>

        <!-- <div class="comment__children">
            <div class="comment__user--children">
                <div>
                    <div class="user__thread--children"></div>
                    <div v-if="false" class="user__thread--childrenContinue"></div>
                </div>
                <span class="user__avatar--children">H</span>
            </div>
            <div class="comment__container">
                <div class="comment__box--children">
                    <div class="comment__topline">
                        <div class="user__info"><strong>Marge</strong> - 3 semanas</div>
                        <i class="material-icons">more_horiz</i>
                    </div>
                    <p class="comment__content"> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab atque magni et aperiam odit fugit! Laudantium veritatis ratione, earum, ullam reprehenderit obcaecati esse quis nam impedit repellendus repellat saepe asperiores?</p>
                </div>
                <div class="comment__actions">
                    <button>
                        <i class="material-icons">favorite</i>
                        {{$t('forum.actions.LIKE')}}
                    </button>
                </div>
            </div>
        </div> -->
        <Modal v-if="modalIsOpen" :isOpen="modalIsOpen" @close="toggleModal" @keyup.esc="toggleModal" >
            <div class="modal__content">
                <div class="modal__title">
                    {{$t('comments.WISH_DELETE_COMMENT')}}
                </div>
                <div class="modal__options">
                    <button class="modal__options--cancel" @click="toggleModal" >{{$t('global.CANCEL')}}</button>
                    <button class="modal__options--accept" @click.stop="deleteCom">{{$t('global.ACCEPT')}}</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { computed, inject, ref } from "vue";
import { useStore } from "vuex";
import CommentBox from "./CommentBox.vue";
import Modal from "../Modal.vue";
import { useI18n } from "vue-i18n"; // Importa useI18n



export default {
    components: {
        CommentBox,
        Modal
    },
    props: ['data', 'index', 'courseIsFinished'],
    emits: ['postComment', 'editComment', 'discardComment', 'liked', 'deleteComment'],
    setup(props, { emit }) {
        // const router = useRouter();
        const { t } = useI18n(); // Obtén la función t para traducciones

        const commentActivate = ref(false)
        const getFile = inject("getFile");
        const formatDate = inject("formatDate");
        const store = useStore();
        const user = computed(() => store.getters.manageUser_user);
        const editEnabled = ref([]);
        const commentLikeLoaded = ref(false)
        const modalIsOpen = ref(false)
        const liked = ref(props.data.isLikedByUser)
        const userLeterColors = ['#ff6961','#77dd77','#d2bead','#84b6f4','#fdcae1', '#9bd3ae', '#a0d2f3', '#a788ab', '#bf9780', '#96c4c4', '#5086c1', '#bdbfbf'];
        const postComment = (comment) => {
            emit('postComment', comment, props.index)
        }


        const editComment = (newComment, index) => {
            emit('editComment', newComment, index, props.data.id)
            editEnabled.value[index] = false
        }

        const discardComment = (index) => editEnabled.value[index] = false

        const closeOptions = (id) => document.getElementById(id).checked = false

        
        async function likeUnlike(){
            if(commentLikeLoaded.value) return
            commentLikeLoaded.value = true
            try {
                if(liked.value){
                    await store.dispatch('forum_deleteLikeComment',props.data.id);
                    emit('liked', props.data.id, false, props.index)
                }
                else{
                    await store.dispatch('forum_postLikeComment',props.data.id);
                    emit('liked', props.data.id, true, props.index)
                }
                liked.value = !liked.value
                commentLikeLoaded.value = false
            } catch (error) {
                console.log(error)
                store.dispatch('notifications_create',{text: t('comments.ERROR_LIKE_COMMENT')})
                commentLikeLoaded.value = false
            }
        }

        const toggleModal = () => modalIsOpen.value = !modalIsOpen.value

        const deleteCom = () => {
            emit('deleteComment', props.data.id, props.index, true)
            closeOptions(props.data.id)
            modalIsOpen.value = false
        }

        const randomColor = (seed)  => {
            seed = (seed || '') + "xx";
            var charCodes = seed.split('').reduce(function(a, b, i) {
                return (i == 1 ? a.charCodeAt(0) : +a) + b.charCodeAt(0);
            });
            return userLeterColors[charCodes % userLeterColors.length]
        }


        return {
            commentActivate,
            getFile,
            formatDate,
            postComment,
            editComment,
            store,
            user,
            editEnabled,
            discardComment,
            closeOptions,
            likeUnlike,
            liked,
            deleteCom,
            modalIsOpen,
            toggleModal,
            randomColor
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.user{
    &__info{
        color: $darkgray;
        font-weight: 400;
        font-size: 14px;
        strong{
            color: $green;
            font-weight: 600;
            font-size: 16px;
        }
    }
    &__avatar{
        height: 45px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $green;
        border-radius: 99px;
        color: #fff;
        margin-top: 8px;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 99px;
        }
        &--children{
            @extend .user__avatar;
            margin-top: 34px;
        }
    }
    &__thread{
        height: calc(100% - 45px);
        width: 2px;
        border: 1px solid $whitegray;
        align-self: center;
        &--children{
            margin-left: 67%;
            align-self: flex-start;
            height: 58px;
            width: 32px;
            border-left: 2px solid $whitegray;
            border-bottom: 2px solid $whitegray;
        }
        &--childrenContinue{
            @extend .user__thread--children; 
            width: 0;
            height: calc(100% - 58px);
        }
    }
}

.dropdown{
    width: fit-content;
    &__face{
        padding: 0;
        border-radius:0;
        border: none;
        width: fit-content
    }
    &__items{
        top: 0;
        left: 100%;
        flex-direction: row;
        width: 0;
        padding:0;
        visibility: hidden;
        li{
            font-size: 17px;
        }
    }
    input {
        display: none;
        &:checked ~ .dropdown__items {
        top: calc(100% + -28px);
        visibility: visible;
        left: -420%;
        padding: 10px;
        width: fit-content;
        opacity: 1;
        }
    }
}
.comment{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    img{
        max-width: 100%;
    }
    &__father{
        display: flex;
        flex-direction: row;
        gap: 6px;
        width: 100%
    }
    &__children{
        display: flex;
        gap: 6px;
    }
    &__container{
        width: 100%;
    }
    &__box{
        padding: 17px;
        background: #f7f7f7;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 12px;
        &--children{
            @extend .comment__box;
            margin-top: 34px;
        }
    }
    &__topline{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        i{
            cursor: pointer;
        }
    }
    &__content{
        color: $black;
        font-weight: 400;
        font-size: 14px;
    }
    &__actions{
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        gap: 28px;
        margin: 12px 0 0 16px;
        button{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6px;
            font-size: 15px;
            font-weight: bold;
            i{
                font-size: 15px;                
            }
            &:disabled{
                opacity: .4;
                cursor: default;
            }
        }
        .liked{
            color: $green;
            i{
                color: $green;
            }
        }
    }
    &__attach{
        a{
            display: flex;
            align-items: center;
        }
    }
    &__user{
        display:flex ;
        flex-direction: column;
        &--children{
            display: flex;
            flex-direction: row;
        }
    }
    &__new-comment {
        @include flex-column;
        gap: 8px;
        width: 100%;
        margin-top: 12px;
        .quillWrapper {
        width: 100%;
        }
        &__files{
        width: 100%;
        margin-bottom: 8px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 4px;
        .file-name{
            padding: 4px 16px;
            padding-right: 8px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            border: 1px solid #ccc;
            background: #f5f5f5;
            border-radius: 44px;
            color: $black;
            font-size: 13px;
            line-height: 16px;
            font-weight: 600;
            .material-icons{
            color: #333;
            font-size: 16px;
            line-height: 16px;
            cursor: pointer;
            }
        }      
        }
        &__actions{
        position: relative;
        width: 100%;
        height: fit-content;
        display: flex;
        justify-content: space-between;
        .upload-file__container{
            input{
            visibility: hidden;
            position: absolute;
            width: 0px;
            height: 0px;
            top: 0;
            left: 0;
            }
            label{
            padding: 4px 16px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            border: 1px solid $green;
            border-radius: 44px;
            color: $green;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            .material-icons{
                color: $green;
                font-size: 22px;
            }
            }
        }
        >div:last-child{
            display: inline-flex;
            gap: 16px;
            button{
            height: 32px;
            padding: 0 16px;
            border-radius: 44px;
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            }
            .btn-comment {
            background-color: $green;
            color: #fff;
            }
            .btn-discard{
            color: $green;
            }
        }
        }
    }
}


.modal{
    &__content{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
    }
    &__title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 20px;
        gap: 18px;
        i{
            color: $green;
            padding: 8px;
            font-size: 20px;
            background-color: rgba($color: $green, $alpha: .3);
            border-radius: 999px;
        }
    }
    &__options{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 18px;
        &--accept{
            font-weight: 600;
            font-size: 16px;
            color: #fff;
            background-color: $green;
            padding: 12px 20px;
            border-radius: 44px;
        }
        &--cancel{
            font-weight: 600;
            font-size: 16px;
            color: $green;
        }
    }
}

</style>